<div class="panel">
  <div class="panel-content">
    <div class="casto-card">
      <div class="content">
        <ng-casto-pose-description
          [title]="title"
          [description]="description"
          [moreThan2YearsLabel]="moreThan2YearsLabel"
          [moreThan2Years]="moreThan2Years"
          [disabled]="toggleDisabled"
          (moreThan2YearsChange)="moreThan2YearsChange.emit($event)"></ng-casto-pose-description>

        @if (hasError && !isLoading) {
          <div class="estimation-error">
            <span [innerHTML]="'price-range.error' | translate"></span>
            <ng-casto-button
              class="secondary"
              [label]="'price-range.retry' | translate"
              (click)="retry.emit()"></ng-casto-button>
          </div>
        } @else {
          <ng-casto-installation-price-range [total]="total" [installation]="installation" [loading]="isLoading">
            <ng-content></ng-content>
          </ng-casto-installation-price-range>
          <ng-casto-installation-details
            [included]="included"
            [toValidate]="toValidate"
            [excluded]="excluded"
            [loading]="isLoading"></ng-casto-installation-details>
        }
      </div>
    </div>
  </div>
</div>
